<app-nav></app-nav>

<main class="about-page">
  <!-- ─── Hero ─────────────────────────────────────────────────────── -->
  <section class="about-hero brand-section">
    <div class="hero-orb hero-orb-blue"></div>
    <div class="hero-orb hero-orb-green"></div>

    <div class="about-hero-inner">
      <span class="brand-eyebrow">JCC Development LLC</span>
      <h1>A small studio building useful things.</h1>
      <p class="brand-lede">
        We're a family-owned software company that builds mobile apps for
        everyday problems. Skip To My Loo is our flagship — and the rest of
        what we do is held to the same bar: practical, polished, and a little
        bit fun.
      </p>
    </div>
  </section>

  <!-- ─── Story ────────────────────────────────────────────────────── -->
  <section class="story brand-section">
    <div class="story-grid">
      <div class="story-eyebrow-block">
        <span class="brand-eyebrow">Our story</span>
        <h2>Built by the Long family.</h2>
      </div>
      <div class="story-prose">
        <p>
          JCC Development LLC is a family-owned software studio founded by
          the Long family. We combine technical depth with a real eye for
          how an app should feel — because the apps we build are the ones
          we use ourselves.
        </p>
        <p>
          <strong>Skip To My Loo</strong> is the clearest example of how we
          think: take a real problem (finding a clean bathroom you'd
          actually want to walk into), make the answer fast, and add a
          layer of fun for the moments when you have a few minutes to kill.
        </p>
      </div>
    </div>
  </section>

  <!-- ─── Values ───────────────────────────────────────────────────── -->
  <section class="values brand-section">
    <div class="section-header">
      <span class="brand-eyebrow">What we care about</span>
      <h2>The principles that shape every release.</h2>
    </div>

    <div class="values-grid">
      @for (value of values; track value.title) {
        <article class="value-card" [attr.data-color]="value.color">
          <div class="value-icon">
            <mat-icon>{{ value.icon }}</mat-icon>
          </div>
          <h3>{{ value.title }}</h3>
          <p>{{ value.description }}</p>
        </article>
      }
    </div>
  </section>

  <!-- ─── Team ─────────────────────────────────────────────────────── -->
  <section class="team brand-section">
    <div class="section-header">
      <span class="brand-eyebrow">The team</span>
      <h2>The three people behind JCC.</h2>
    </div>

    <div class="team-grid">
      @for (member of teamMembers; track member.name) {
        <article class="team-card">
          <div class="member-image">
            <img [src]="member.image" [alt]="member.name">
          </div>
          <h3>{{ member.name }}</h3>
          <p class="role">{{ member.role }}</p>
          <p class="bio">{{ member.bio }}</p>
        </article>
      }
    </div>
  </section>

  <!-- ─── CTA ──────────────────────────────────────────────────────── -->
  <section class="about-cta brand-section">
    <div class="about-cta-inner">
      <span class="brand-eyebrow">Get in touch</span>
      <h2>Have an idea, or just want to say hi?</h2>
      <p class="brand-lede">
        We read every message. Tell us what you'd love an app to do better
        — Skip To My Loo started with exactly that kind of conversation.
      </p>
      <a class="brand-btn brand-btn-primary brand-btn-large" routerLink="/contact">
        <mat-icon>email</mat-icon>
        Contact us
      </a>
    </div>
  </section>
</main>

<app-footer></app-footer>
